import { render } from "./rule_item.vue?vue&type=template&id=43ed79e5&scoped=true"
import script from "./rule_item.vue?vue&type=script&lang=js"
export * from "./rule_item.vue?vue&type=script&lang=js"

import "./rule_item.vue?vue&type=style&index=0&id=43ed79e5&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-43ed79e5"

export default script